import { api } from './auth.service';

// ════════════════════════════════════════════════════════════════════════════
// notificacao.service.js — Centro de notificações (sininho) — r61
// ════════════════════════════════════════════════════════════════════════════

const notificacaoService = {
  // Lista até 50 notificações mais recentes do usuário
  listar: async (usuarioId, { apenasNaoLidas = false } = {}) => {
    const params = { usuario_id: usuarioId, _t: Date.now() };
    if (apenasNaoLidas) params.apenas_nao_lidas = '1';
    const res = await api.get('/notificacoes', { params });
    // r173: backend expõe lida_em (não `lida`); normaliza pro que o sino usa
    return (res.data || []).map(n => ({ ...n, lida: n.lida_em ? 1 : 0 }));
  },

  // Só a contagem de não-lidas (pro badge do sininho — leve)
  contagem: async (usuarioId) => {
    const res = await api.get('/notificacoes/contagem', {
      params: { usuario_id: usuarioId, _t: Date.now() },
    });
    return res.data.qtd || 0;
  },

  marcarLida: async (id, usuarioId) => {
    const res = await api.patch(`/notificacoes/${id}/lida`, { usuario_id: usuarioId });
    return res.data;
  },

  marcarTodasLidas: async (usuarioId) => {
    const res = await api.patch('/notificacoes/marcar-todas-lidas', { usuario_id: usuarioId });
    return res.data;
  },
};

export default notificacaoService;
